<script>
  import { onMount } from 'svelte'
  export let leftId = ''
  export let rightId = ''
  export let baseUrl = '/dag-api/get-convo/'
  export let messages = []
  let incomingMessages = []
  let prevDate

  let fixTheAwfulDateFormatting = (dateString) => {
      let tmpTime = dateString.replace('/Date(', '')
      tmpTime = tmpTime.replace(')/', '')
      tmpTime = Number(tmpTime)
      let fixedDatetime = new Date(tmpTime)
      
      
      const [month, day, year] = [fixedDatetime.getMonth() + 1, fixedDatetime.getDate(), fixedDatetime.getFullYear()]
      return `${month}/${day}/${year}`
  }

  async function getLatestConversation() {
    let tmpIncomingMessages = []

    if(leftId.length && rightId.length) {
      var tmpMsgs = await fetchLatestConversation()

      if(incomingMessages.length < 1 || incomingMessages === undefined || incomingMessages === null ) {
        messages = incomingMessages
      } else {
        // already has messages. Figure out what needs to be appended.
        // ...but for now...
        // console.log('assigning the messages var', incomingMessages);
        messages = incomingMessages
      }
    } else {
      console.log('Please ensure both formIDs are configured.')
    }
  }

  async function fetchLatestConversation() {
    await fetch( baseUrl + leftId + '/' + rightId )
      .then( res => {
        if(!res.ok) {
          throw new Error("failed to retrieve convo [not OK]");
        } else {
          var tmp = res.json();
          // console.log('res OK', tmp);
          return tmp;
          // return res.json();  
        }
      })
      .then(data => {
        // instantiate Conversation component with data
        // console.log('returning with these msgs:', data.messages);
        incomingMessages = data.messages;
        return data.messages;
      })
      .catch(function(err) {
        console.log('EX CAUGHT could not fetch conversation:', err);
        return [];
      })
  }

  const checkForNewMessages = () => {
    if(leftId && rightId) {
      getLatestConversation();
    }
  }

  $: {
		if(leftId && rightId) {
      getLatestConversation();
    } else {
      console.log('did not getLatestConversation. Left + right current vals:', leftId + rightId )
    }
	}

  // we use this func to tell whether we should render the date so the same date won't show twice
  let compareDate = (date) => {
    let incomingDate = fixTheAwfulDateFormatting(date);
    if( incomingDate === prevDate ) {
      prevDate = incomingDate;
      return false;
    } else {
      prevDate = incomingDate;
      return true;
    }
  }

  onMount(()=> {
    window.setTimeout(checkForNewMessages(), 20000);
  })
</script>

<div class="conversation">
  <ol class="conversation-list{ messages.length <= 0 ? ' empty' : '' }">
    { #if messages.length }
      {#each messages as { isLeft, DateSubmitted, FormResponseBody, FirstName, LastName, UserPhoneNumber, UserEmail, JobTitle }}
        <li class="msg-container msg-{ isLeft ? 'left': 'right' }">
          { #if compareDate(DateSubmitted) }<time>{ fixTheAwfulDateFormatting(DateSubmitted) }</time>{ /if }
          <div class="msg-wrap">
            <div class="msg">
              { FormResponseBody }
            </div>
          </div>
          <address>
            <a href="mailto:{ UserEmail }" title="Send an email to { FirstName } { LastName }">{ FirstName } { LastName }</a>
          </address>
        </li>
      { /each }
    { :else }
        <li class="empty-msg">No messages</li>
    { /if }
  </ol>
</div>
<style>
  .conversation {
    --bg: #FFF;
    background-color: var(--bg);
    padding: 1.5rem;
    max-height: 685px;
    overflow: hidden;
    border-radius: 1.5rem 1.5rem 0 0;
  }
  .conversation-list {
    /*--sentColor: #e00122;
    --sentColor: #333;*/
    --sentColor: #e5e5e5;

    --receiveColor: #636363;
    --author-color: #e00122;
    color: black;


    display: flex;
    flex-direction: column;
    /* max-width: 480px; */
    max-height: 650px;
    margin: 0 auto;
    padding: 0 1.5rem;
    list-style: none;
    overflow-y: scroll;
    overflow-x: hidden;
  }

  .conversation-list.empty { overflow-y: hidden;}
  .conversation-list::-webkit-scrollbar {
    width: 1em !important;
  }

  .conversation-list::-webkit-scrollbar-thumb {
    background-color: #424242 !important;
    outline: 0px solid transparent !important;
    border-radius: 2rem !important;
  }

  .conversation-list::-webkit-scrollbar-track {
    -webkit-box-shadow: unset !important;
    box-shadow: unset !important;
    background-color: #ccc !important;
  }
  .msg-container {
    min-width: 280px;
    padding: 0 0 30px 0;

    --msg-width: 50vw;
    --msg-wrap-width: 90vw;
    --author-width: 98%;
  }

  .msg-wrap {
    width: 100%;
    max-width: var(--msg-wrap-width);
    margin: 0 auto;
    display: flex;
    position: relative;
  }

  .msg-right .msg-wrap {
    display: flex;
    flex-direction: row-reverse;
    /* grid-template-columns: [lgap] auto [author] var(--author-width) [msg] var(--msg-width) [rgap] auto; */
  }

  .msg-left .msg-wrap {
    display: flex;
    /* grid-template-columns: [lgap] auto [msg] var(--msg-width) [author] var(--author-width) [rgap] auto */
  }

  .msg {
    position: relative; /* Setup a relative container for our psuedo elements */
    max-width: var(--msg-width);

    margin-bottom: 2px;
    padding: 10px 20px;

    line-height: 24px;
    word-wrap: break-word; /* Make sure the text wraps to multiple lines if long */
    border-radius: 25px;
  }

  .msg:before {
    width: 20px;
  }

  .msg:after {
    width: 26px;
    background-color: var(--bg); /* All tails have the same bg cutout */
  }

  .msg:before,
  .msg:after {
    position: absolute;
    bottom: 0;
    height: 25px; /* height of our bubble "tail" - should match the border-radius above */
    content: '';
  }

  .msg-right .msg {
    align-self: flex-end;
    background: var(--sentColor);
  }

  .msg-right .msg:before {
    right: -7px;
    background-color: var(--sentColor);
    border-bottom-left-radius: 16px 14px;
  }

  .msg-right .msg:after {
    right: -26px;
    border-bottom-left-radius: 10px;
  }


  .msg-left .msg {
    color: white;
    align-self: flex-start;
    background: var(--receiveColor);
  }
  .msg-left .msg:before {
    left: -7px;
    background-color: var(--receiveColor);
    border-bottom-right-radius: 16px 14px;
  }

  .msg-left .msg:after {
    left: -26px;
    border-bottom-right-radius: 10px;
  }

  li.empty-msg {
    color: black;
    margin: 0 auto;
    padding: 40px;
    text-align: center;
  }

  address {
    color: white;
    padding: 0;
    width: var(--author-width);
    margin: 0 auto;
    font-size: 2rem;
  }

  address a {
    display: block;
    width: 100%;
    color: var(--author-color);
  }

  .msg-right address a {
    text-align: right;
  }

  .msg-left address a {
    text-align: left;
  }

  time {
    color: black;
    display: block;
    width: 100%;
    text-align: center;
    font-size: 2rem;
    font-weight:700;
    padding: 0 0 10px 0;
  }
</style>
